import { IAction } from "../userMetadataReducer";
import * as types from "../../types/API/gateEntry";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getGateEntriesByIdReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case types.GET_GATE_ENTRIES_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case types.GET_GATE_ENTRIES_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case types.GET_GATE_ENTRIES_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const getAllGateEntriesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case types.GET_ALL_GATE_ENTRIES:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ALL_GATE_ENTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case types.GET_ALL_GATE_ENTRIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const updateGateEntryReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case types.UPDATE_GATE_ENTRY:
      return {
        ...state,
        loading: true,
      };
    case types.UPDATE_GATE_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case types.UPDATE_GATE_ENTRY_FAILED:
      return {
        ...state,
        loading: false,

        error: action.payload.error,
      };
    default:
      return state;
  }
}

export const createGateEntryReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case types.CREATE_GATE_ENTRY:
      return {
        ...state,
        loading: true,
      };
    case types.CREATE_GATE_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case types.CREATE_GATE_ENTRY_FAILED:  
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}